module.exports = __webpack_public_path__ + "img/ico_sub_responsive.8e3760a1.svg";